import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import { colors } from "../../setupUtils";
import { Divider, IconButton } from "@mui/material";
import CreateEditIndividualSKUDate from "./CreateEditIndividualSKUDate";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPGState } from "../productGroupSetupSlice";
import { useEffect } from "react";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1300,
  height: 560,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 2,
};

export default function CreateBasicModal() {
  const dispatch = useDispatch();
  const pgState = useSelector((store) => store.productGroupSetup);
  const { selectedSKUs, createFromDate, createToDate, createIndDateUpdated } =
    pgState;
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const [open, setOpen] = React.useState(false);
  const [tempSKUs, setTempSKUs] = useState(selectedSKUs);
  const [validationError, setValidationError] = useState("");

  // useEffect(() => {
  //   console.log("createIndDateUpdated", createIndDateUpdated);
  //   if (createIndDateUpdated) {
  //     setTempSKUs(selectedSKUs);
  //   }
  // }, [createIndDateUpdated, setTempSKUs]);

  useEffect(() => {
    setTempSKUs(selectedSKUs);
  }, [setTempSKUs]);

  // useEffect(() => {
  //   setInitialTempData();
  // }, []);

  // function setInitialTempData() {
  //   setTempSKUs(selectedSKUs);
  // }

  function showMessage(message, severity) {
    dispatch(setPGState("createMessage", message));
    dispatch(setPGState("createMessageSeverity", severity));
    dispatch(setPGState("createMessageOpen", true));
  }

  const handleOpen = () => {
    setOpen(true);
    setTempSKUs(selectedSKUs);
  };
  const handleClose = () => {
    setOpen(false);
    setTempSKUs(selectedSKUs);
  };

  const handleSave = () => {
    let errorOccured = false;

    // check if any SKU has invalid date range
    const invalidSKU = tempSKUs.find((sku) =>
      dayjs(sku.effectiveStartDate).startOf('day').isAfter(dayjs(sku.effectiveEndDate).startOf('day'))
    );

    if (invalidSKU) {
      showMessage(
        "The SKU effective end date cannot be less than the start date",
        "error"
      );
      setOpen(true);
      errorOccured = true;
    }

    if (errorOccured) return;

    // Check if the effectiveStartDate falls outside the group range
    console.log("createFromDate", createFromDate);

    const startDateValidationError = tempSKUs.find((sku) =>
      dayjs(sku.effectiveStartDate).startOf('day').isBefore(dayjs(createFromDate).startOf('day'))
    );

    if (startDateValidationError) {
      showMessage(
        "The SKU effective start date falls outside the effective start date of Product group",
        "error"
      );
      setOpen(true);
      errorOccured = true;
    }

    if (errorOccured) return;

    const endDateValidationError = tempSKUs.find((sku) =>
      dayjs(sku.effectiveEndDate).startOf('day').isAfter(dayjs(createToDate).startOf('day'))
    );

    if (endDateValidationError) {
      showMessage(
        "The SKU effective end date falls outside the effective end date of Product group",
        "error"
      );
      setOpen(true);
      errorOccured = true;
    }

    if (errorOccured) return;

    // Check if at least one SKU's start date matches with the group start date
    const isStartDateMatched = tempSKUs.some((sku) =>
      dayjs(sku.effectiveStartDate).startOf('day').isSame(dayjs(createFromDate).startOf('day'))
    );

    if (!isStartDateMatched) {
      showMessage(
        "At least one SKU effective start date has to match with the start date of Product group",
        "error"
      );
      setOpen(true);
      errorOccured = true;
    }

    // Check if at least one SKU's end date matches with the group end date
    const isEndDateMatched = tempSKUs.some((sku) =>
      dayjs(sku.effectiveEndDate).startOf('day').isSame(dayjs(createToDate).startOf('day'))
    );
    console.log("tempSKUs", tempSKUs);
    console.log("createToDate", createToDate);

    if (!isEndDateMatched) {
      showMessage(
        "At least one SKU effective end date has to match with the end date of Product group",
        "error"
      );
      setOpen(true);
      errorOccured = true;
    }

    // If no errors, save the changes
    if (!errorOccured) {
      dispatch(setPGState("selectedSKUs", tempSKUs));
      dispatch(setPGState("createIndDateUpdated", true));
      setOpen(false);
    }
  };
  const loadMore = (startIndex, stopIndex) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newItems = selectedSKUs.slice(startIndex, stopIndex + 1);
  
        setTempSKUs((prev) => {
          const existingIds = new Set(prev.map((c) => c.productID));
          const merged = [...prev];
          newItems.forEach((item) => {
            if (!existingIds.has(item.productID)) {
              merged.push(item);
            }
          });
          return merged;
        });
  
        resolve();
      }, 300);
    });
  };

  return (
    <div>
      <Button
        startIcon={<EditCalendarIcon />}
        disabled={!isRestrictedAccess}
        sx={{
          bgcolor: "darkred.light",
          color: "white.main",
          textTransform: "none",
          mt: 2,
          "&:hover": {
            bgcolor: "darkred.main",
          },
          marginLeft: "calc(100% - 162px)",
        }}
        onClick={handleOpen}
      >
        Update Dates
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              zIndex: 1,
              color: "grey",
            }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{ ml: 1, fontWeight: "bold", color: "darkred.light" }}
          >
            Edit Start Date / End Date
          </Typography>
          <Divider sx={{ mb: 3 }} />
          {/* <CreateAutoComplete /> */}
          <CreateEditIndividualSKUDate
            tempSKUs={tempSKUs}
            setTempSKUs={setTempSKUs}
            loadMore={loadMore}
          />
          <Box>
            <Button
              sx={{
                bgcolor: "darkred.light",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                position: "fixed",
                bottom: 10,
                right: 20,
                zIndex: 1,
                "&:hover": {
                  bgcolor: "darkred.main",
                },
              }}
              onClick={handleSave}
            >
              Save Dates
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
